export enum AccessType {
    Edit="Edit", 
    View="View"
}

export enum FarmType{
    Registered= "Registered",
    Enrolled = "Enrolled",
    Qualified = "Qualified",
    Disqualified = "Disqualified",
    SoilPhMap = "SoilPhMap"
}
export enum EngagementType{
    Engagement1= "Engagement1",
    Engagement2 = "Engagement2",
    Engagement3 = "Engagement3",
    Engagement4 = "Engagement4"
}
export enum ViewType{
    Table= "Table",
    Map = "Map"
}
export enum OperationType{
    Qualification= "Qualification",
    Deployment = "Deployment",
    Engagement = "Engagement",
    Conversation = "Conversation"
}
export enum QualityCheckNewType{
    Dashboard= "Dashboard",
    Defects= "Defects",
    Sources= "Source"
}
export enum HseType{
    Dashboard= "Dashboard",
    Report= "Report",
}
export enum LabOperationType{
    Summary= "Summary",
    Samples = "Samples",
    Carts = "Carts",
    Shipments = "Shipments"
}

export enum WarehouseType{
    Warehouse="Warehouse",
    QualityCheck = "QualityCheck",
    Dashboard = "Dashboard"
}

export enum QualityCheckType{
    Truck="Truck",
    Source="Source"
}


export enum FormType1{
    View= "View",
    Update = "Update"
}

export enum DeploymentType{
    PreSampling= "Pre-sampling",
    Deployment = "Deployment",
    StartSample = "Start sample",
    HarvestSample = "Harvest sample",
    EndYearSample = "End of year sample",
    End3rdYearSample= "End of 3rd year sample",
    End5thYearSample = "End of 5th year sample"
}

export enum ProgressType{
    approved="approved",
    rejected = "rejected",
    pending = "pending"
}

export enum ComponentType{
    dashboard = "dashboard",
    farmApp ="farmApp",
    engagement ="engagement",
    deployment = "deployment",
    warehouseApp ="warehouseApp",
    supplyDemand ="supplyDemand",
    Planning ="Planning",
    conversation="conversation",
    summary="summary",
    samples ="samples",
    carts = "carts",
    shipments= "shipments",
    summaryDashboard = "summaryDashboard",
    qualityCheck = "qualityCheck",
    qualityCheckNew = "qualityCheckNew",
    qualityDefect="qualityDefect",
    qualitySource="qualitySource",
    hseDashboard="hseDashboard",
    hseReport="hseReport",
    warehouseDashboard="warehouseDashboard"
}


export enum Progress{
    Pending = "pending",
    Completed = "completed"
}

export enum SupplyType{
    Request = "Request",
    History = "History"
}

export enum DataType1{
    Graph="Graph",
    Table="Table"
}

export enum SupplyStatus{
    NA="NA",
    InAllocation="InAllocation",
    InDispatch="InDispatch",
    Rejected="Rejected",
    Delivered="Delivered",
    Canceled="Canceled"
}
export enum AccessType2{
    e="e",  // edit access
    v="v"  //view access
}
export enum QualityAccessType{
    QualityManager="Quality Manager",
    VillageManager="Village Manager",
    LocationManager="Location Manager"
}

export enum ActionType{
   Add="Add",
   Update="Update"
}

export enum InputType{
    Text="Text",
    Number = "Number"
}
export enum SummaryType{
    "Yearly"='Yearly',
    "HalfYearly"='Half Yearly',
    "Quarterly"='Quarterly',
    "Monthly"='Monthly',
    "Daily"='Daily',
}

export enum QualityActionStatus{
    "Pending"="Pending",
    "Approved"="Approved",
    "Rejected"="Rejected",
    "NA"="NA"
}
export enum PlanningType{
    "Planning"="Planning",
    "Actual"="Actual",
    "Dashboard"="Dashboard"
}